import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TransferConnectV2State } from '../store/reducers';
import { getCheckoutFormData } from '../store/selectors/checkout.selectors';
import { TransferConnectV2CheckoutFormData } from '../types';

@Injectable()
export class FormDataGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<TransferConnectV2State>,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    const loyaltyProgramId = next.queryParamMap.get('loyaltyProgramId');
    // @ts-ignore
    return this.store
      .select(getCheckoutFormData, { id: loyaltyProgramId })
      .pipe(
        map((formData) => {
          // @ts-ignore
          if (this.formDataFilled(formData)) {
            return true;
          } else {
            this.router.navigate([`/transfer/checkout/${loyaltyProgramId}`]);

            return false;
          }
        }),
      );
  }

  private formDataFilled(formData: TransferConnectV2CheckoutFormData): boolean {
    return formData !== null;
  }
}
